// Single source of truth for source taxonomy labels — used across all four catalog views.
// Canonical labels established by Monitor (per orchestrator decision 2026-06-03).

export const SOURCE_LABELS: Record<string, string> = {
  feed_and_manifest: 'In feed · Page live',
  feed_only:         'In feed · No page yet',
  manifest_only:     'Delisted · Page still live',
  not_in_aeo:        'Outside AEO scope',
};

export function sourceLabel(key: string | null | undefined): string {
  if (!key) return '—';
  return SOURCE_LABELS[key] ?? key;
}
